import { DEFAULT_DISPLAY_THEME, THEME_BY_KEY } from 'config/theme.config';
import {
  ACCESSIBILITY_COLOR_MODES,
  ACCESSIBILITY_THEME_BY_COLOR_MODE,
} from 'config/accessibilityTheme.config';

export { DEFAULT_DISPLAY_THEME };

export const normalizeDisplayTheme = (themeName) =>
  THEME_BY_KEY[themeName] ? themeName : DEFAULT_DISPLAY_THEME;

export const resolveDisplayTheme = (themeName) =>
  THEME_BY_KEY[normalizeDisplayTheme(themeName)] || THEME_BY_KEY[DEFAULT_DISPLAY_THEME];

export const normalizeAccessibilityColorMode = (colorMode) =>
  ACCESSIBILITY_THEME_BY_COLOR_MODE[colorMode] ? colorMode : ACCESSIBILITY_COLOR_MODES.DEFAULT;

export const resolveAccessibilityTheme = (colorMode) =>
  ACCESSIBILITY_THEME_BY_COLOR_MODE[normalizeAccessibilityColorMode(colorMode)];
